import { getCommonWidget } from "../../dashWidgetHelper";
import {
  commonWidgets, getProfuturoAtencion, getProfuturoFacilidad, getProfuturoNpsAcumulado,
  getProfuturoNpsPorMes, getProfuturoSatisfaccion, getProfuturoCustomerJourney,
  PRODUTURO_PIE_COLORS
} from "../commonWidgetsProfuturo";

export default {
  title: 'Acompañamiento Dashboard',
  description: 'Acompañamiento Dashboard',
  backgroundClassName: (filters: FiltersUI) => 'epsilon-hero-bg',
  widgets: (filters: FiltersUI) => [
    {
      title: 'Principales Indicadores',
      ////position: [0, 0],
      size: [4, 1],
      type: 'label',
      config: { color: '#B7AADC' },
    },
    getProfuturoNpsAcumulado({
      //position: [0, 1],
      size: [1, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_13'
    }),
    getProfuturoNpsPorMes({
      //position: [1, 1],
      size: [1, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_13',
      helpText: "A partir de tu experiencia con el Asesor Patrimonial Profuturo para la contratación de tu préstamo, en una escala del 0 al 10, ¿qué tan probable es que recomiendes a Profuturo a tus amigos y familiares?"
    }),
    getProfuturoSatisfaccion({
      //position: [2, 1],
      size: [1, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_2',
      helpText: '¿Qué tan satisfecho estás con la atención recibida por parte de tu asesor patrimonial Profuturo durante la contratación de tu préstamo?'
    }),
    getProfuturoFacilidad({
      //position: [3, 1],
      size: [1, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_3',
      helpText: '¿Qué tan fácil fue el proceso de contratación del préstamo?'
    }),
    

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: 'Satisfacción: clientes insatisfechos',
      size: [2, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_15',
      helpText: '¿Cuál fue el principal inconveniente que experimentaste durante el proceso de atención de tu préstamo? ',
      extraConfigs: {
        itemGap: 6,
        center: ['27%', '55%'],
        colors: PRODUTURO_PIE_COLORS,
      }
    }),

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: 'Satisfacción: Clientes satisfechos',
      size: [2, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_16',
      helpText: '¿Qué aspecto de la atención del asesor fue más valioso para ti durante el proceso? ',
      extraConfigs: {
        itemGap: 6,
        center: ['27%', '55%'],
        colors: PRODUTURO_PIE_COLORS,
      }
    }),


    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: 'Facilidad: clientes insatisfechos',
      size: [2, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_19',
      helpText: '¿Por qué no te resultó fácil?',
      extraConfigs: {
        itemGap: 6,
        center: ['27%', '55%'],
        colors: PRODUTURO_PIE_COLORS,
      }
    }),
    

    {
      title: 'Atributos de experiencia',
      //position: [0, 5],
      size: [4, 1],
      type: 'label',
      config: { color: '#B7AADC' },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'Me sentí seguro al compratir mi información y datos durante el proceso',
      //position: [0, 6],
      size: [4, 1],
      helpText: '¿Qué tan de acuerdo estás con cada uno de los siguientes aspectos?',
      indicator: 'prestamo_sofom_encuesta_pregunta_8'
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'Me sentí acompañado por el asesor patrimonial Profuturo',
      //position: [0, 7],
      size: [4, 1],
      helpText: '¿Qué tan de acuerdo estás con cada uno de los siguientes aspectos?',
      indicator: 'prestamo_sofom_encuesta_pregunta_9'
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'Recibí la información que necesitaba de forma clara y precisa',
      //position: [0, 8],
      size: [4, 1],
      helpText: '¿Qué tan de acuerdo estás con cada uno de los siguientes aspectos?',
      indicator: 'prestamo_sofom_encuesta_pregunta_10'
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'Recibí la asesoría necesaria para que pudiera tomar la mejor decisión',
      //position: [0, 9],
      size: [4, 1],
      helpText: '¿Qué tan de acuerdo estás con cada uno de los siguientes aspectos?',
      indicator: 'prestamo_sofom_encuesta_pregunta_11'
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'Las explicaciones acerca del pago y los montos a descontar fueron precisas y exactas',
      //position: [0, 10],
      size: [4, 1],
      helpText: '¿Qué tan de acuerdo estás con cada uno de los siguientes aspectos?',
      indicator: 'prestamo_sofom_encuesta_pregunta_12'
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'stackedBar',
      title: 'El proceso de contratación y la velocidad de la entrega del dinero fueron adecuadas',
      //position: [0, 11],
      size: [4, 1],
      helpText: '¿Qué tan de acuerdo estás con cada uno de los siguientes aspectos?',
      indicator: 'prestamo_sofom_encuesta_pregunta_6'
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: 'Uso del préstamo  ',
      size: [2, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_71',
      helpText: 'Las personas solicitan préstamos por diferentes razones. En tu caso,¿cuál fue el principal motivo al momento de solicitarlo?',
      extraConfigs: {
        itemGap: 6,
        center: ['27%', '55%'],
        colors: PRODUTURO_PIE_COLORS,
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMediumSiNo',
      title: 'Conocimiento del producto',
      helpText: 'Antes de contratar tu préstamo, ¿sabías que Profuturo ofrecía préstamos a pensionados del IMSS (Ley 73)?',
      size: [2, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_20',
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'pieGenericMedium',
      title: 'Medio de conocimiento',
      size: [2, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_21',
      helpText: '¿Cómo te enteraste?',
      extraConfigs: {
        itemGap: 6,
        center: ['27%', '55%'],
        colors: PRODUTURO_PIE_COLORS,
      },
      extras: {
        formula: 'count-number'
      },
    }),
   getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'wordCount',
      title: 'Sugerencias y comentarios',
      helpText: '¿Hay alguna sugerencia o comentario que nos quieras realizar sobre la contratación de tu préstamo?',
      //position: [0, 16],
      size: [2, 2],
      indicator: 'prestamo_sofom_encuesta_pregunta_14'
    }),
    
    getProfuturoCustomerJourney({
      id: 'cj-ventaPrestamosSOFOM',
      //position: [0, 3],
      size: [3, 2],
      indicators: [
        { name: 'prestamo_sofom_encuesta_pregunta_2', formula: 'count-number' }, //csat
        { name: 'prestamo_sofom_encuesta_pregunta_3', formula: 'count-number' }, //facilidad
        { name: 'prestamo_sofom_encuesta_pregunta_13', formula: 'nps-10' }, //nps
      ],
      title: 'Customer Journey: Top Two Box',

    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: 'Análisis de Sentimientos',
      //position: [0, 17],
      size: [4, 4],
      indicator: 'SENTIMENT'
    }),
  ]
} as DasboardConfig
